import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Label, Row, Col } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField, AvFeedback } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import { locales, languages } from 'app/config/translation';
import { getUser, reset, updateUser } from './user.reducer';
import { IRootState } from 'app/shared/reducers';

export interface IUserManagementUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ login: string }> {}

export interface IUserManagementUpdateState {
  isNew: boolean;
}

export class UserManagementUpdate extends React.Component<IUserManagementUpdateProps, IUserManagementUpdateState> {
  state: IUserManagementUpdateState = {
    isNew: !this.props.match.params || !this.props.match.params.login
  };

  componentDidMount() {
    this.props.getUser(this.props.account.login);
  }

  componentDidUpdate() {
    const { baseResponse } = this.props;
    if (baseResponse && baseResponse.status) {
      this.showMessage(baseResponse.status);
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  showMessage = status => {
    switch (status) {
      case 200:
        toast.success(translate('userManagement.message.updateSuccess'), { autoClose: 6000 });
        return;
      case 201:
        toast.error(translate('register.messages.error.emailexists'), { autoClose: 6000 });
        return;
      case 204:
        toast.error(translate('register.messages.error.mobileExists'), { autoClose: 6000 });
        return;
      default:
        toast.error(translate('userManagement.message.updateFailure'), { autoClose: 6000 });
        return;
    }
  };

  saveUser = (event, values) => {
    this.props.updateUser(values);
  };

  handleClose = () => {
    this.props.history.push('/');
  };

  render() {
    const isInvalid = false;
    const { user, loading, updating, roles } = this.props;
    let emailVerified = '';
    let email = '';
    let phoneVerified;
    let phone;
    if (user.emails && user.emails.length) {
      const emailsArr = user.emails;
      Object.keys(emailsArr).forEach((key, index) => {
        if (emailsArr[key].type && emailsArr[key].type === 'emailVerified') {
          emailVerified = emailsArr[key].value;
        } else {
          email = emailsArr[key];
        }
      });
    }
    if (user.phoneNumbers && user.phoneNumbers.length) {
      const phoneArr = user.phoneNumbers;
      Object.keys(phoneArr).forEach((key, index) => {
        if (phoneArr[key].type && phoneArr[key].type === 'phoneVerified') {
          phoneVerified = phoneArr[key].value;
        } else {
          phone = phoneArr[key];
        }
      });
    }
    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h1>
              <Translate contentKey="userManagement.home.updateInfo">Edit a User</Translate>
            </h1>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm onValidSubmit={this.saveUser}>
                {user.id ? (
                  <AvGroup>
                    <AvField type="hidden" className="form-control" name="idReg" value={user.id} />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label for="login">
                    <Translate contentKey="userManagement.login">Login</Translate>
                  </Label>
                  <AvField type="text" className="form-control" name="login" required readOnly value={user.userName} />
                </AvGroup>
                <AvGroup>
                  <Label for="firstName">
                    <Translate contentKey="userManagement.firstName">First Name</Translate>
                  </Label>
                  <AvField
                    type="text"
                    className="form-control"
                    name="firstName"
                    validate={{
                      maxLength: {
                        value: 50,
                        errorMessage: translate('entity.validation.maxlength', { max: 50 })
                      }
                    }}
                    value={user.name ? user.name.givenName : ''}
                  />
                </AvGroup>
                <AvGroup>
                  <Label for="lastName">
                    <Translate contentKey="userManagement.lastName">Last Name</Translate>
                  </Label>
                  <AvField
                    type="text"
                    className="form-control"
                    name="lastName"
                    validate={{
                      maxLength: {
                        value: 50,
                        errorMessage: translate('entity.validation.maxlength', { max: 50 })
                      }
                    }}
                    value={user.name ? user.name.familyName : ''}
                  />
                  <AvFeedback>This field cannot be longer than 50 characters.</AvFeedback>
                </AvGroup>
                <AvGroup>
                  <AvField
                    name="email"
                    label={translate('global.form.email.label')}
                    placeholder={translate('global.form.email.placeholder')}
                    type="email"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: translate('global.messages.validate.email.required')
                      },
                      email: {
                        errorMessage: translate('global.messages.validate.email.invalid')
                      },
                      minLength: {
                        value: 5,
                        errorMessage: translate('global.messages.validate.email.minlength')
                      },
                      maxLength: {
                        value: 254,
                        errorMessage: translate('global.messages.validate.email.maxlength')
                      }
                    }}
                    value={email ? email : emailVerified}
                  />
                </AvGroup>
                <AvGroup check>
                  <Label>
                    <AvInput type="checkbox" name="verifyEmail" value={emailVerified ? true : false} />{' '}
                    <Translate contentKey="userManagement.verifyEmail">Email Verify</Translate>
                  </Label>
                </AvGroup>
                <AvGroup>
                  <AvField
                    name="mobile"
                    label={translate('global.form.mobile.label')}
                    placeholder={translate('global.form.mobile.placeholder')}
                    validate={{
                      number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
                      minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
                      maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
                    }}
                    value={phone ? phone : phoneVerified}
                  />
                </AvGroup>
                <AvGroup check>
                  <Label>
                    <AvInput type="checkbox" name="verifyPhone" value={phoneVerified ? true : false} />{' '}
                    <Translate contentKey="userManagement.verifyPhone">PhoneNumber Verify</Translate>
                  </Label>
                </AvGroup>
                <Button tag={Link} to="/" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />
                  &nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button color="primary" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />
                  &nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  user: storeState.userManagement.userInfo,
  roles: storeState.userManagement.authorities,
  loading: storeState.userManagement.loading,
  updating: storeState.userManagement.updating,
  account: storeState.authentication.account,
  baseResponse: storeState.userManagement.baseResponse
});

const mapDispatchToProps = { getUser, reset, updateUser };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagementUpdate);
